import styled from "@emotion/styled";
import { IconButton, Toolbar, Tooltip } from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import { useEffect, useState } from "react";
import BoxTheme from "../../generic/box";
import MenuElevationHeader from "./menuElevationHeader";
import React from "react";
import HelpHeader from "./helpHeader";
import { Box } from "@mui/system";
import NotificationsIcon from '@mui/icons-material/Notifications';
import bannertop from "../../../assets/bannertop.png";
import ModalManual from "../../modalManual";

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  width: `calc(100% - ${theme.spacing(9)})`,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {


    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export default function AppBarHeader({ open, handleDrawerOpen, handleDrawerClose }) {
  const [modal, setModal] = useState(false)
  const [openHeader, setOpenHeader] = useState(open);
  useEffect(() => {
    setOpenHeader(open);
  }, [open]);

  return (
    <>
      <AppBar position="fixed" sx={{ boxShadow: "none", borderBottom: "1px solid ", borderColor: openHeader ? '#aceaff' : "#00a7e1", background: '#e0eaff' }} open={openHeader}>
        <Toolbar
          sx={{

            border: "10px",
            borderRadius: "10px",
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "#e0eaff",
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            sx={{
              marginRight: 5,
              color: "#2B3A8B",

            }}
            onClick={openHeader ? handleDrawerClose : handleDrawerOpen}
          >
            <img src={bannertop} style={{ height: '50px', marginLeft: "13px" }}></img>
          </IconButton >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Tooltip title="Notificações">
              <NotificationsIcon color="blueSys"></NotificationsIcon>
            </Tooltip>
            <HelpHeader
            onClick={() => {setModal(true);  }}
            ></HelpHeader>
            <>
              <BoxTheme
                sx={{ display: "flex", alignItems: "center", textAlign: "center", marginRight: "35px" }}
              >
                <MenuElevationHeader />
              </BoxTheme>
            </>
          </Box>
        </Toolbar>
      </AppBar>
      <ModalManual 
      imageUrls = {[]}
      open = {modal}
      handleClose= {() => setModal(false)}
       ></ModalManual>
    </>
  );
}
